// extracted by mini-css-extract-plugin
module.exports = {"menuDropdown":"MenuDropdown_menuDropdown__ff8a9","anchored":"MenuDropdown_anchored__98df2","fullWidth":"MenuDropdown_fullWidth__8e1c1"};